"use strict";

exports.averages = function(data, metric, startDate, granularity, periodpoints) {
  var result = new Array(periodpoints)
    , len = data.length
    , row
    , value
    , periodindex

  for(periodindex = 0; periodindex < periodpoints; ++periodindex) {
    result[periodindex] = {
      timestamp: new Date(startDate.getTime() + periodindex * granularity),
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY,
      sum: 0,
      count: 0
    };
  }

  for(var i = 0; i < len; ++i) {
    value = +data[i][metric];
    if (isFinite(value) && value !== 0) {
      periodindex = ((data[i].timestamp - startDate) / granularity) % periodpoints;
      if (periodindex < 0) periodindex += periodpoints;
      row = result[periodindex|0];
      if (value < row.min) row.min = value;
      if (value > row.max) row.max = value;
      row.sum += value;
      ++row.count;
    }
  }

  for(periodindex = 0; periodindex < periodpoints; ++periodindex) {
    row = result[periodindex];
    if (row.count === 0) {
      row.min = 0;
      row.max = 0;
      row.avg = 0;
    }
    else {
      row.avg = row.sum / row.count;
    }
  }

  return result;
};
